export function useOnClick(props) {
  return function onClick() {
    let el = document.getElementById('invoice-section')
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
